import { ResourceID } from "../resource_loader/resource_id.js";

export const VFX_3D_ATLAS_SIZE = 2048;

/**
 * List of ResourceIDs to pack in the 3D VFX global atlas
 */
export const VFX_3D_ATLAS_CONFIG: ResourceID[] = [
  ResourceID.ParticleGlow1,
  ResourceID.CircleGlow1,
  ResourceID.CircleGlow2,
  ResourceID.EllipseGlow1,
  ResourceID.SparkGlow4,
  ResourceID.WaveGlow1,
  ResourceID.WaveGlow2,
  ResourceID.ShockwaveGlow1,
  ResourceID.ShockwaveGlow2,
  ResourceID.ShockwaveGlow3,
  ResourceID.ShockwaveGlow4,
  ResourceID.ShockwaveGlow5,
  ResourceID.ShockwaveGlow6,

  ResourceID.Smog,
  ResourceID.Fire,

  // Smoke
  ResourceID.SmokePuff1,
  ResourceID.SmokePuff2,
  ResourceID.SmokePuff3,
  ResourceID.SmokePuff4,

  // Jam splash textures
  ResourceID.JamCherryTexture,
  ResourceID.JamFigTexture,
  ResourceID.JamLemonTexture,
  ResourceID.JamPlumTexture,

  // Fluid particle textures
  ResourceID.FluidParticle1,
  ResourceID.FluidParticle2,
  ResourceID.FluidParticle3,

  // Watermelon splash textures
  ResourceID.WatermelonJuiceTexture,

  ResourceID.PerlinNoiseTexture,
  ResourceID.CloudNoiseTexture,
  ResourceID.VornoiNoiseTexture,

  // Glass shards
  ResourceID.GlassShard1,
  ResourceID.GlassShard2,
  ResourceID.GlassShard3,
  ResourceID.GlassShard4,

  // Splinters
  ResourceID.SplinterStone1,
  ResourceID.SplinterStone2,
  ResourceID.SplinterStone3,

  ResourceID.SplinterIce1,
  ResourceID.SplinterIce2,
  ResourceID.SplinterIce3,

  ResourceID.SplinterWood1,
  ResourceID.SplinterWood2,
  ResourceID.SplinterWood3,

  ResourceID.SplinterBrick1,
  ResourceID.SplinterBrick2,
  ResourceID.SplinterBrick3,

  ResourceID.SplinterColumn1,
  ResourceID.SplinterColumn2,
  ResourceID.SplinterColumn3,

  ResourceID.SplinterGreenBox1,
  ResourceID.SplinterGreenBox2,
  ResourceID.SplinterGreenBox3,

  ResourceID.SplinterPurpleBox1,
  ResourceID.SplinterPurpleBox2,
  ResourceID.SplinterPurpleBox3,

  ResourceID.SplinterPlasticBlue1,
  ResourceID.SplinterPlasticBlue2,
  ResourceID.SplinterPlasticBlue3,

  ResourceID.SplinterPlasticGreen1,
  ResourceID.SplinterPlasticGreen2,
  ResourceID.SplinterPlasticGreen3,

  ResourceID.SplinterPlasticLightBlue1,
  ResourceID.SplinterPlasticLightBlue2,
  ResourceID.SplinterPlasticLightBlue3,

  ResourceID.SplinterPlasticOrange1,
  ResourceID.SplinterPlasticOrange2,
  ResourceID.SplinterPlasticOrange3,

  ResourceID.SplinterPlasticPink1,
  ResourceID.SplinterPlasticPink2,
  ResourceID.SplinterPlasticPink3,

  ResourceID.SplinterPlasticPurple1,
  ResourceID.SplinterPlasticPurple2,
  ResourceID.SplinterPlasticPurple3,

  ResourceID.SplinterPlasticRed1,
  ResourceID.SplinterPlasticRed2,
  ResourceID.SplinterPlasticRed3,

  ResourceID.SplinterPlasticYellow1,
  ResourceID.SplinterPlasticYellow2,
  ResourceID.SplinterPlasticYellow3,
];
